const Hamburger = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.0300279 7.13431C0.0300279 7.13431 0.015014 7.02272 0.007507 6.96693C2.8525e-08 6.91113 0.112248 6.89603 0.168372 6.88848L9.04025 7.00131C9.20862 6.97866 9.27976 7.08269 9.40702 7.17918C9.47816 7.28322 9.5493 7.38726 9.62794 7.54709C9.62794 7.54709 9.64296 7.65868 9.59434 7.72203C9.53822 7.72958 9.4896 7.79292 9.42597 7.74468L0.554089 7.63185C0.441841 7.64695 0.31458 7.55046 0.243442 7.44643C0.172304 7.34239 0.101166 7.23835 0.0300279 7.13431Z"
        fill="currentColor"
      />
      <path
        d="M0.0300279 4.30912C0.0300279 4.30912 0.015014 4.19753 0.007507 4.14173C2.8525e-08 4.08594 0.112248 4.07083 0.168372 4.06328L9.04025 4.17611C9.20862 4.15346 9.27976 4.2575 9.40702 4.35399C9.47816 4.45802 9.5493 4.56206 9.62794 4.7219C9.62794 4.7219 9.64296 4.83348 9.59434 4.89683C9.53822 4.90438 9.4896 4.96773 9.42597 4.91948L0.554089 4.80665C0.441841 4.82176 0.31458 4.72527 0.243442 4.62123C0.172304 4.51719 0.101166 4.41315 0.0300279 4.30912Z"
        fill="currentColor"
      />
      <path
        d="M0.0300279 1.48392C0.0300279 1.48392 0.015014 1.37233 0.007507 1.31654C2.8525e-08 1.26074 0.112248 1.24564 0.168372 1.23809L9.04025 1.35092C9.20862 1.32827 9.27976 1.4323 9.40702 1.52879C9.47816 1.63283 9.5493 1.73687 9.62794 1.8967C9.62794 1.8967 9.64296 2.00829 9.59434 2.07163C9.53822 2.07919 9.4896 2.14253 9.42597 2.09429L0.554089 1.98146C0.441841 1.99656 0.31458 1.90007 0.243442 1.79604C0.172304 1.692 0.101166 1.58796 0.0300279 1.48392Z"
        fill="currentColor"
      />
    </svg>
  )
}

Hamburger.displayName = 'Hamburger'

export default Hamburger
